module.exports = __webpack_public_path__ + "static/media/linkedin-3.ac9ddb23.svg";